
import { makeObservable, observable, runInAction } from "mobx";
import { RootStoreType, TransportLayerUpdateType, TransportLayerType } from "./root_store";
import { KeyedType } from '../types';
import { api_get } from "api/utils";

export type BaseStoreType = {
	items: TransportLayerUpdateType[];
	transportLayer:  TransportLayerType;
	receiveUpdate: (json: TransportLayerUpdateType, debugging?: boolean) => void;
}



export class BaseStore<TProps extends KeyedType, TModel extends KeyedType> {
	items: TModel[] = [];
	rootStore: RootStoreType | null = null;
	transportLayer:  TransportLayerType;

    // handle automatic batch fetching
    _batch_fetched_uuids = [] as string[];
    _batch_fetch_queue = [] as string[];
    _batch_fetch_queue_timer = 0;
    _batch_fetch_url = '';



	constructor(rootStore: RootStoreType, transportLayer: TransportLayerType) {
		this.rootStore = rootStore;
		this.transportLayer = transportLayer;
		makeObservable(this, { items: observable });
	}

    updateItem(json: KeyedType) {
        this._receiveUpdate(json, false);
    }

	_receiveUpdate(json: KeyedType, debugging=false) {
		// Match by key or uuid to handle both urlsafe keys and uuid identifiers
		const item = this.items.find((c: any) =>
			c.key === json.key || c.uuid === json.uuid || c.key === json.uuid || c.uuid === json.key);
		if (item && item.updateProps) {
            if(debugging === true) { console.log("_receiveUpdate() updating\n%o" , json); }
            // does this need to run in action?
            runInAction(() => {
                // this will be here
                if(item.updateProps) {
                    if(debugging) console.log("_receiveUpdate() item.updateProps");
                    // replace just the new item
                    const itemIndex = this.items.findIndex(
                        (c: KeyedType) => c.key === json.key || c.uuid === json.uuid || c.key === json.uuid || c.uuid === json.key);
                    item.updateProps(json as TProps);
                    if(debugging) console.log("_receiveUpdate new json: %d, %o", itemIndex, json);
                    this.items.splice(itemIndex, 1, item);
                }
            });
		} else {
            if(debugging === true) { console.log("_receiveUpdate() this.items.length: %d (Start)" , this.items.length); }

            if(debugging === true) { console.log("_receiveUpdate() pushing\n%o" , json); }
			runInAction(() => {
				this.items.push(new (this.modelConstructor())(json as TProps));
                if(debugging === true) { console.log("_receiveUpdate() this.items.length: %d (finish)" , this.items.length); }
			});
		}


        // if(this.afterReceiveUpdate) {
        //     runInAction(() => {
        //         this.afterReceiveUpdate(json);
        //     });
        // }

	}

	receiveUpdate(json: TProps | TProps[], debugging=false) {
		if (Array.isArray(json)) {
			json.forEach((c) => this._receiveUpdate(c, debugging));
		} else {
			this._receiveUpdate(json as KeyedType, debugging);
		}
        return json;
	}





	modelConstructor(): new (attributes: TProps) => TModel {
		throw new Error("Override this method in subclass");
	}

	getItemByKey(key: string) {
		// Match by key or uuid to handle both urlsafe keys and uuid identifiers
		const item = this.items.find((c: any) => c.key === key || c.uuid === key);
		if(item) {
			return item;
		}
		return null;
	}

    forwardTypes() {
        console.log("no forwardTypes");

    }


    ////////////////////////
    // start of batched

    batchedFetchByUuid(workKey: string, uuid: string, url: string) {
        // if we already have it, don't go again
        if(this._batch_fetched_uuids.includes(uuid))
            return null;

        // otherwise, make a not that we fetched it
        this._batch_fetched_uuids.push(uuid);

        // Add it to the current queue
        this._batch_fetch_queue.push(uuid);

        // set the time if we have to
        if(!this._batch_fetch_queue_timer) {
            this._batch_fetch_queue_timer = window.setTimeout(() => {
                this._batch_do_fetch_queue(workKey, url);
            }, 100);
        }

        return null;
    }

    async _batch_do_fetch_queue(workKey: string, url: string) {
       const items = this._batch_fetch_queue
        this._batch_fetch_queue = [];
        this._batch_fetch_queue_timer = 0;

        if(items.length === 0)
            return;
        // fetch the items
        const params = {
            identity: workKey,
            uuids: items.join(',')
        }
        api_get(url, params)
            .then(async (response) => {
                if(response.ok) {
                    const result = await response.json();
                    this.receiveUpdate(result.items);
                }
                return null;
            })
            .catch((err) => {
                console.error("Error with batched fetch", err);
            });
    }

    // end of batched
    ///////////////////////////////
}
